import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { T } from '@shared/components';

import { activityImportedFromTypes } from '../../constants';
import { activityImportedFromSel } from '../../duck';

const getImportedTranslation = importType => {
  let translationId;
  switch (importType) {
    case activityImportedFromTypes.SCOUTBOOK_IMPORT:
      translationId = 'logImport';
      break;
    case activityImportedFromTypes.GTFA_IMPORT:
      translationId = 'gftaImport';
      break;
    default:
      return null;
  }
  return (
    <T size="5" bold>
      <i>
        <FormattedMessage id={`progress.common.${translationId}`} />
      </i>
    </T>
  );
};

const ImportText = () => {
  const activityImportedFrom = useSelector(activityImportedFromSel);
  return getImportedTranslation(activityImportedFrom);
};

export default ImportText;
